import NextImage from 'next/image'

type ImageProps = React.ComponentProps<typeof NextImage>

const Image = ({ priority, ...props }: ImageProps) => {
  const isProduction = process.env.NODE_ENV === 'production'
  return <NextImage {...props} priority={isProduction ? priority : false} />
}

export default Image
